export enum TeamStatus {
  Active = 'Active',
  Archived = 'Archived'
}
